import React, { useMemo } from 'react';
import { type IRootWidget } from '../../schema/widgets/repository/containers/root/IRootWidget.ts';

interface IWidgetsRootContextValue {
  root: IRootWidget | null | undefined;
}

/**
 * Permette di accedere al tree dei widget da qualsiasi punto della pagina
 * di editing.
 */
// TODO Unificare con l'`useDndItemsEditor`
export const WidgetRootContext = React.createContext<IWidgetsRootContextValue>({
  root: null,
});

export interface IWidgetsRootContextProviderProps {
  root: IRootWidget | null | undefined;
  children: React.ReactNode;
}

export function WidgetsRootContextProvider(
  props: IWidgetsRootContextProviderProps,
) {
  const { root } = props;
  const value = useMemo(() => ({ root }), [root]);

  return (
    <WidgetRootContext.Provider value={value}>
      {props.children}
    </WidgetRootContext.Provider>
  );
}

export const useWidgetRootContext = () => {
  return React.useContext(WidgetRootContext);
};
